<template>
  <div class="label-value flex flex-ali-center">
    <div class="label h100" :style="labelStyle">{{label}}{{symbol}}</div>
    <div class="value flex1 h100">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    symbol: {
      type: String,
      default: '：'
    },
    label: {
      type: String,
      default: '标签'
    },
    labelWidth: [String , Number],
  },
  data() {
    return {
      
    };
  },
  computed:{
    labelStyle(){
      let style = {}
      this.labelWidth && (style.width = this.labelWidth + 'px')
      return style
    }
  },
  mounted(){
  },
  methods:{
    
  }
};
</script>
<style lang="less" scoped>
.label-value{
  .label{
    text-align: right;
  }
  .value{
    text-align: left;
  }
}
</style>
